import React, { useState, useEffect } from 'react';

const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [showIOSPrompt, setShowIOSPrompt] = useState(false);

  useEffect(() => {
    // Check if iOS
    const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(isIOSDevice);

    // Check if already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                         window.navigator.standalone === true;

    if (isIOSDevice && !isStandalone) {
      // Show iOS prompt after a delay
      const timer = setTimeout(() => {
        const dismissed = localStorage.getItem('bitarot-ios-prompt-dismissed');
        if (!dismissed) {
          setShowIOSPrompt(true);
        }
      }, 3000);
      return () => clearTimeout(timer);
    }

    // For Android/Desktop - listen for beforeinstallprompt
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!promptInstall) return;
    
    promptInstall.prompt();
    const { outcome } = await promptInstall.userChoice;
    
    if (outcome === 'accepted') {
      setSupportsPWA(false);
    }
  };

  const dismissIOSPrompt = () => {
    setShowIOSPrompt(false);
    localStorage.setItem('bitarot-ios-prompt-dismissed', 'true');
  };

  // iOS Install Instructions
  if (isIOS && showIOSPrompt) {
    return (
      <div style={{
        position: 'fixed',
        bottom: '80px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
        padding: '1.5rem',
        borderRadius: '1rem',
        border: '2px solid rgba(139, 92, 246, 0.3)',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
        maxWidth: '340px',
        width: '90%',
        animation: 'slideUp 0.3s ease-out'
      }}>
        <button 
          onClick={dismissIOSPrompt}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'none',
            border: 'none',
            color: '#9ca3af',
            fontSize: '1.2rem',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>
        
        <h3 style={{color: '#8b5cf6', marginBottom: '0.75rem', fontSize: '1.1rem'}}>
          📱 Install Bitarot
        </h3>
        <p style={{color: '#cbd5e1', fontSize: '0.9rem', marginBottom: '1rem', lineHeight: '1.5'}}>
          Add Bitarot to your home screen for the best experience:
        </p>
        <ol style={{color: '#9ca3af', fontSize: '0.85rem', paddingLeft: '1.25rem', marginBottom: '0'}}>
          <li style={{marginBottom: '0.5rem'}}>
            Tap the <strong style={{color: '#3b82f6'}}>Share</strong> button <span style={{fontSize: '1rem'}}>⬆️</span>
          </li>
          <li style={{marginBottom: '0.5rem'}}>
            Scroll down and tap <strong style={{color: '#8b5cf6'}}>"Add to Home Screen"</strong>
          </li>
          <li>
            Tap <strong style={{color: '#22c55e'}}>"Add"</strong> in the top right
          </li>
        </ol>
      </div>
    );
  }

  // Android/Desktop Install Button
  if (!supportsPWA) return null;

  return (
    <button
      onClick={handleInstallClick}
      style={{
        position: 'fixed',
        bottom: '80px',
        right: '20px',
        background: 'linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)',
        color: 'white',
        border: 'none',
        padding: '0.75rem 1.25rem',
        borderRadius: '2rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 10px 25px rgba(139, 92, 246, 0.4)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        animation: 'pulse 2s infinite'
      }}
    >
      📱 Install App
    </button>
  );
};

export default InstallPWA;
